import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { FeatureFlags } from '~constants/featureFlags';
import { AccountCapacityTypeahead } from '~hooks/useAccount/models';
import { useFeatureFlag } from '~utils/hooks/useFeatureFlag';

import TrucksAssignedCount from './TrucksAssignedCount';

interface VendorTrucksAssignedSummaryProps {
  vendor: AccountCapacityTypeahead;
}

export default function VendorTrucksAssignedSummary({
  vendor,
}: VendorTrucksAssignedSummaryProps) {
  const theme = useTheme();
  const isTypedTruckCapacityEnabled = useFeatureFlag({
    featureFlagKey: FeatureFlags.typedTruckCapacityV1,
  });
  const showsEquipmentTypeStats =
    isTypedTruckCapacityEnabled && vendor.equipmentTypeStats.length > 0;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, minWidth: 0 }}>
      <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
        <OverflowAwareText
          variant="body2"
          sx={{
            color: vendor.scheduleOn
              ? theme.brandV2.colors.treadBlue2
              : theme.brandV2.colors.treadBlack,
            flex: 1,
            fontWeight: 600,
          }}
        >
          {vendor.name}
        </OverflowAwareText>

        <TrucksAssignedCount
          assignedCount={vendor.currentAssignedCount}
          stacked
          totalCount={vendor.currentCapacityCount}
        />
      </Box>

      {showsEquipmentTypeStats &&
        vendor.equipmentTypeStats.map((equipmentTypeStat) => (
          <Box
            key={equipmentTypeStat.id}
            sx={{ alignItems: 'center', display: 'flex', gap: 1 }}
          >
            <OverflowAwareText
              sx={{ color: theme.brandV2.colors.treadGray2, flex: 1, fontSize: '12px' }}
            >
              {equipmentTypeStat.equipmentType.name}
            </OverflowAwareText>

            <TrucksAssignedCount
              assignedCount={equipmentTypeStat.assignedCount}
              sx={{ fontSize: '12px', whiteSpace: 'nowrap' }}
              totalCount={equipmentTypeStat.committedCount}
            />
          </Box>
        ))}
    </Box>
  );
}
